Auth = require 'db/auth'
_ = require 'underscore'
{ usesEnglish } = require 'lib/util'

activeChannel = ->
  Auth.me().get('channels')?.active

testOrgsForExperiment = (orgsInTest) ->
  _.find(Auth.me().get('idOrganizations'), (orgId) ->
    orgsInTest.indexOf(orgId) != -1
  )

inDueSoonExperiment = ->
  orgsInTest = []

  testOrgsForExperiment(orgsInTest)

inUpNextExperiment = ->
  orgsInTest = [
    '59dc130d8f0b9e2b7c2b7fa1',
    '58adea146fcdb5f4e50bebf2',
    '538627f73cbb44d1bfbb58f0',
    '5971fa54ba3b05dccb85cb01',
    '5972209e8f7e0888f79ed880',
    '594ad0ff4781c20133e9bf5e',
    '587576fa353f09964aebbe74',
    '59ad33df3fb66e764442db80',
    '59e619b1de65846a9688adfb',
    '583cf548ba6e0919a354c25b',
    '583c653a8fe9264f7c19e45a',
    '583df243ad29ee237f3f2188',
    '583dffcc107f5c30477a8f8d',
    '59abdb62e653568a38746356',
    '59ad3ce928674b5f5b07aa39',
    '594aa562f43993c584f4ff55',
    '594a56e14e1dde66ad67c9bd',
    '58025f49eea59d13ddf8c4c3',
    '59722c420d55bf9613f0756a',
    '583a54498443fd8419376703',
    '582a1bc7b22a3efd5478d598',
    '58470f00ce319f5877651f33',
    '584af251a0ee8fb2c9c656fd',
    '514f3af5eab7c26466001d27',
    '576a72adb4929e1bfc34d247'
  ]

  testOrgsForExperiment(orgsInTest)

module.exports =
  allMembers: ->
    return true
  alphaMembers: ->
    activeChannel() == 'alpha'
  englishMembers: ->
    usesEnglish()
  alphaEnglishMembers: ->
    usesEnglish() && activeChannel() == 'alpha'
  betaEnglishMembers: ->
    usesEnglish() && activeChannel() == 'beta'
  activityFeedMembers: ->
    return false
  dueSoonMembers: ->
    usesEnglish() && inDueSoonExperiment()
  upNextMembers: ->
    usesEnglish() && inUpNextExperiment()



// WEBPACK FOOTER //
// ./app/scripts/lib/experiments/audience-definitions.coffee